import { Node } from "tiptap";

export default class Iframe extends Node {
  get name() {
    return "iframe";
  }

  get schema() {
    return {
      attrs: {
        src: {
          default: null
        },
        width: {
          default: null
        },
        height: {
          default: null
        },
        style: {
          default: null
        }
      },
      group: "block",
      selectable: false,
      parseDOM: [
        {
          tag: "iframe",
          getAttrs: dom => ({
            src: dom.getAttribute("src"),
            width: dom.getAttribute("width"),
            height: dom.getAttribute("height"),
            style: dom.getAttribute("style")
          })
        }
      ],
      toDOM: node => [
        "iframe",
        {
          src: node.attrs.src,
          width: node.attrs.width,
          height: node.attrs.height,
          style: node.attrs.style,
          frameborder: 0,
          allowfullscreen: "true"
        }
      ]
    };
  }

  get view() {
    return {
      props: ["node", "updateAttrs", "view"],
      computed: {
        src: {
          get() {
            return this.node.attrs.src;
          },
          set(src) {
            this.updateAttrs({
              src
            });
          }
        },
        width: {
          get() {
            return this.node.attrs.width;
          },
          set(width) {
            this.updateAttrs({
              width
            });
          }
        },
        height: {
          get() {
            return this.node.attrs.height;
          },
          set(height) {
            this.updateAttrs({
              height
            });
          }
        },
        style: {
          get() {
            return this.node.attrs.style;
          },
          set(style) {
            this.updateAttrs({
              style
            });
          }
        }
      },
      template: `
        <div class="iframe">
          <iframe class="iframe__embed" :src="src" :width="width" :height="height" :style="style"></iframe>
        </div>
      `
      // <input class="iframe__input" @paste.stop type="text" v-model="src" v-if="view.editable" />
    };
  }

  commands({ type }) {
    return attrs => (state, dispatch) => {
      const { selection } = state;
      const position = selection.$cursor
        ? selection.$cursor.pos
        : selection.$to.pos;
      console.log("position:", position);
      const node = type.create(attrs);
      const transaction = state.tr.insert(position, node);
      dispatch(transaction);
    };
  }
}
